export const sortAsc = (arr, key) => {
  if (key) {
    return arr.sort((a, b) => a[key].localeCompare(b[key]))
  } else {
    return arr.sort((a, b) => a.localeCompare(b))
  }
}
